// extracted by mini-css-extract-plugin
export default {"slider":"Carousel_slider__1+PFN","img":"Carousel_img__jxBMn"};